import React, { useEffect, useState } from 'react';
import { getDropShadowValueFromElement } from '~/common/editor/helpers';
import EditorColor from '../../../FormComponents/EditorColor';

type ShadowColorProps = {
    disabled: boolean;
    onChange: (prop: string, value: any) => void;
    selectedElement: any;
};

const ShadowColor = ({ disabled, onChange, selectedElement }: ShadowColorProps) => {
    const { locked } = selectedElement;
    const color = getDropShadowValueFromElement(selectedElement).color;

    return (
        <EditorColor
            name="dropShadow"
            property="fillColor"
            colorTypes={['SOLID']}
            color={color}
            disabled={locked || disabled}
            onChange={onChange}
            testId="shots_styling_shadow__color"
            selectedElement={selectedElement}
            isGradientDisabled
        />
    );
};

export default ShadowColor;
